<template>
  <ForieLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 1"
  />
  <TeLoader
    class="t3-loader"
    v-show="showLoader && this.$store.state.domainSystemX == 2"
  />

  <subPageBanner pageTitle="txt_hakkimizda" />

  <div class="container-fuild aboutus-page-area mt-5">
    <div class="container">
      <div class="row aboutus-page-info">
        <p>
          {{ companyDescription }}
        </p>

        <div class="col-12 mt-5 row m-0 p-0">
          <div class="col-12 col-sm-6 col-lg-3 mb-4 aboutus-company-summary">
            <i
              class="material-icons-outlined d-block"
              style="color: var(--m3--source---primary)"
              data-v-141c21a4=""
              >segment</i
            >
            <strong>{{
              this.$store.getters.getWordLocale("txt_faaliyet_alanlari")
            }}</strong>
            <ul>
              <li v-for="(segment, si) in companySegments" :key="si">
                {{ segment }}
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-lg-3 mb-4 aboutus-company-summary">
            <i
              class="material-icons-outlined d-block"
              style="color: var(--m3--source---secondary)"
              data-v-141c21a4=""
              >category</i
            >
            <strong>{{
              this.$store.getters.getWordLocale("txt_kategorileri")
            }}</strong>
            <ul>
              <li v-for="(cat, ci) in companyCategories" :key="ci">
                {{ cat }}
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-lg-3 mb-4 aboutus-company-summary">
            <i
              class="material-icons-outlined d-block"
              style="color: var(--m3--source---tertiary)"
              data-v-141c21a4=""
              >card_membership</i
            >
            <strong>{{this.$store.getters.getWordLocale("txt_sertifikalari")}}</strong>
            <p v-if="certificates == ''" class="alert">-</p>
            <ul v-else>
              <li v-for="(cer, cindx) in certificates.split(',')" :key="cindx">
                {{ cer }}
              </li>
            </ul>
          </div>
          <div class="col-12 col-sm-6 col-lg-3 mb-4 aboutus-company-summary">
            <i
              class="material-icons-outlined d-block"
              style="color: var(--m3--source---primary)"
              data-v-141c21a4=""
              >branding_watermark</i
            >
            <strong>{{this.$store.getters.getWordLocale("txt_marka")}}</strong>
            <p v-if="brands == ''" class="alert">-</p>
            <ul v-else>
              <li v-for="(brand, nindx) in brands.split(',')" :key="nindx">
                {{ brand }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subPageBanner from "./components/SubPageBanner.vue";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";

export default {
  components: {
    TeLoader,
    ForieLoader,
    subPageBanner,
  },
  data() {
    return {
      gettingSegments: true,
      showLoader: true,
      companyKeywords: "",
      companyName: "",
      membershipName: "",
      membershipIcon: "",
      employeeCount: "",
      companyCategories: [],
      companyDescription: "",
      certificates: [],
      companySegments: [],
      brands: "",
      companyAddress: "",
      contactPerson: "",
      phone: "",
      sigmentsIdList: [],
    };
  },
  methods: {
    async getCompanyInformation() {
      var result = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: this.$store.state.singleCompanyIdX,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.$store.state.singleCompanyFullInfoX = result;

      this.buildCompanyInfo(result);
    },
    buildCompanyInfo(variable) {
      this.membershipName =
        variable.CompanyActiveMembership.Localizations.length == 0
          ? ""
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
          ? variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.memebrshipIcon = variable.CompanyActiveMembership.Icon;

      variable.CompanyContactInformations.forEach((element) => {
        var address = element.Address;
        if (this.companyAddress == "") {
          this.companyAddress = address;
        }
        if (this.contactPerson == "") {
          this.contactPerson = element.ContactPearson;
        }

        element.Phones.forEach((tel) => {
          if (this.phone == "") {
            this.phone = tel;
          }
        });
      });

      this.$store.state.singleCompanyFullCategoriesX.forEach((categoryId) => {
        this.companyCategories.push(categoryId);
      });

      var categories = [];
      if (this.companyCategories.length > 0) {
        var unique = this.companyCategories.filter(this.onlyUnique);
        unique.forEach((ele) => {
          var category = this.$store.state.mainCategoriesX.filter(
            (q) => parseInt(q._id) == ele
          );

          var categoryName =
            category[0].Localizations.length == 0
              ? ""
              : category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : category[0].Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          categories.push(categoryName);
        });

        this.companyCategories = [];
        this.companyCategories = categories;
      }

      this.$store.state.singleCompanyFullSegmentsX.forEach((element) => {
        var segmentId = element;
        this.sigmentsIdList.push(segmentId);
      });

      this.brands = variable.CompanyCustomFields.Brands;
      this.certificates = variable.CompanyCustomFields.Certificates;
      this.employeeCount = variable.CompanyCustomFields.PersonelCount;

      this.showLoader = false;

      if (this.$store.state.singleCompanySegmentNamesX.length == 0) {
        this.getCompanySegments();
      } else {
        this.gettingSegments = false;
        this.companySegments = this.$store.state.singleCompanySegmentNamesX;
      }
    },
    async getCompanySegments() {
      this.gettingSegments = true;
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanySegments`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            segments: this.sigmentsIdList,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companySegments = data))
        .catch((err) => console.log(err.message));

      var segments = [];
      if (this.companySegments.length > 0) {
        this.companySegments.forEach((segment) => {
          var segmentName =
            segment.Localizations.length == 0
              ? ""
              : segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : segment.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          segments.push(segmentName);
          this.$store.state.singleCompanySegmentNamesX.push(segmentName);
        });

        this.companySegments = [];
        this.companySegments = segments;

        this.gettingSegments = false;
      }
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.showLoader = true;
    this.scrollToTop();
    this.companyName =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Name
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Name;

    this.companyDescription =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) =>
          q.LangCode == this.$store.state.langCodeX &&
          q.DescriptionContent != null
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].DescriptionContent
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].DescriptionContent;

    this.fullDescription = this.companyDescription.length >= 250 ? false : true;

    this.companyKeywords =
      this.$store.state.singleCompanyDetailsX.Localizations.filter(
        (q) => q.LangCode == this.$store.state.langCodeX
      ).length > 0
        ? this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          )[0].Keywords
        : this.$store.state.singleCompanyDetailsX.Localizations.filter(
            (q) => q.LangCode != this.$store.state.langCodeX
          )[0].Keywords;

    this.userId = parseInt(
      this.$store.state.singleCompanyDetailsX.rlt_User_Id
    );

    if (this.$store.state.singleCompanyFullInfoX.length == 0) {
      this.getCompanyInformation();
    } else {
      this.buildCompanyInfo(this.$store.state.singleCompanyFullInfoX);
    }
  },
};
</script>

<style scoped>
.aboutus-page-info {
  padding-left: 230px;
  padding-right: 230px;
}
.aboutus-company-summary > i {
  font-size: 33px;
  margin-bottom: 20px;
}
.aboutus-company-summary > strong {
  display: block;
  margin-bottom: 12px;
}

.page-laoder {
  position: fixed !important;
  background-color: transparent !important;
  top: 50%;
}
</style>
